module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "camo-background-hack"
  }, [_c('Home')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5df56f9b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/KUIUAnchorage.vue
// module id = 386
// module chunks = 1